import { DomainModel } from 'domains/models';
import Workflow from '../workflow';
import { LinkType } from './linkType';
import { RoutineType } from './routineType';
import { Status } from './status';

interface Props {
  eventId: number;
  projectId: number | null;
  userId: string;
  routineType: RoutineType;
  uid: string;
  startedAt: Date | null;
  endedAt: Date | null;
  currentBatchUid: string;
  currentBatchEndedAt: string | null;
  name: string;
  status: Status;
  isRemind: boolean;
  linkType: LinkType;
  customLink: string | null;
  duration: number;
  canDelete: boolean;
  slackChannel: string | null;
  workflows: Workflow[];
}

export default class Routine extends DomainModel {
  eventId: number | null;
  projectId: number | null;
  userId: string;
  routineType: RoutineType;
  uid: string;
  startedAt: Date | null;
  endedAt: Date | null;
  currentBatchUid: string;
  currentBatchEndedAt: string | null;
  name: string;
  status: Status;
  isRemind: boolean;
  linkType: LinkType;
  customLink: string | null;
  duration: number;
  canDelete: boolean;
  slackChannel: string | null;
  workflows: Workflow[];

  constructor(props: Props) {
    super(props);
    this._className = 'Routine';
    this.eventId = props.eventId;
    this.routineType = props.routineType;
    this.userId = props.userId;
    this.startedAt = props.startedAt;
    this.endedAt = props.endedAt;
    this.currentBatchUid = props.currentBatchUid;
    this.currentBatchEndedAt = props.currentBatchEndedAt;
    this.projectId = props.projectId;
    this.uid = props.uid;
    this.name = props.name;
    this.status = props.status;
    this.isRemind = props.isRemind;
    this.linkType = props.linkType;
    this.customLink = props.customLink;
    this.duration = props.duration;
    this.canDelete = props.canDelete;
    this.slackChannel = props.slackChannel;
    this.workflows = props.workflows;
  }

  static permited = [
    'name',
    'status',
    'linkType',
    'customLink',
    'currentBatchUid',
    'currentBatchEndedAt',
    'slackChannel',
    'duration',
    'workflows',
    'startedAt',
    'endedAt',
    'isRemind',
  ];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';

    p = 'projectId';
    if (!scopes || scopes.includes(p)) {
      if (!this.projectId) {
        this.addError(p, 'E001');
      }
    }
    p = 'routineType';
    if (!scopes || scopes.includes(p)) {
      if (!this.routineType) {
        this.addError(p, 'E001');
      }
    }
    p = 'uid';
    if (!scopes || scopes.includes(p)) {
      if (!this.uid) {
        this.addError(p, 'E001');
      }
    }
    p = 'status';
    if (!scopes || scopes.includes(p)) {
      if (!this.status) {
        this.addError(p, 'E001');
      }
    }
    p = 'isRemind';
    if (!scopes || scopes.includes(p)) {
      if (!this.isRemind) {
        this.addError(p, 'E001');
      }
    }
    p = 'linkType';
    if (!scopes || scopes.includes(p)) {
      if (!this.linkType) {
        this.addError(p, 'E001');
      }
    }
    p = 'duration';
    if (!scopes || scopes.includes(p)) {
      if (!this.duration) {
        this.addError(p, 'E001');
      }
    }

    p = 'startedAt';
    if (!scopes || scopes.includes(p)) {
      if (this.startedAt) {
      }
    }

    p = 'endedAt';
    if (!scopes || scopes.includes(p)) {
      if (this.endedAt) {
      }
    }

    return super.isValid();
  }

  // 何分前にroutineを開始ステータスにするかの設定
  static startAfterMinute(): number {
    return 15;
  }
}
